module.exports = __webpack_public_path__ + "img/nl.4461f499.svg";